var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useAriaLive } from '@ally/use-aria-live';
import { ScreenReaderOnly } from '../ScreenReaderOnly';
var ErrorNotificationWrapper = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var _b = _a.theme, colors = _b.colors, font = _b.font;
    return "\n    line-height: ".concat(font.body.xs.lineHeight, ";\n    color: ").concat(colors.error, ";\n    font-size: ").concat(font.body.xs.size, ";\n    font-weight: bold;\n    width: 100%;\n    display: inline-block;\n  ");
});
var ErrorNotification = React.forwardRef(function (_a, ref) {
    var id = _a.id, tabIndex = _a.tabIndex, errorMessage = _a.errorMessage, screenReaderErrorId = _a.screenReaderErrorId, screenReaderErrorMessage = _a.screenReaderErrorMessage, className = _a.className;
    var announceAssertive = useAriaLive().announceAssertive;
    useEffect(function () {
        if (errorMessage && !screenReaderErrorMessage) {
            announceAssertive(errorMessage);
        }
        // intentionally leaving off the screenReaderErrorMessage prop
        // and announceAssertive function
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [errorMessage]);
    useEffect(function () {
        if (screenReaderErrorMessage) {
            announceAssertive(screenReaderErrorMessage);
        }
        // intentionally leaving off the announceAssertive function
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [screenReaderErrorMessage]);
    return (React.createElement(React.Fragment, null,
        React.createElement(ErrorNotificationWrapper, { id: id, ref: ref, tabIndex: tabIndex, className: className }, errorMessage),
        !!screenReaderErrorMessage && (React.createElement(ScreenReaderOnly, { id: screenReaderErrorId, as: "span" }, screenReaderErrorMessage))));
});
/* istanbul ignore next */
var ErrorNotificationForProps = function () { return React.createElement(React.Fragment, null); };
export { ErrorNotification, ErrorNotificationForProps };
var templateObject_1;
//# sourceMappingURL=ErrorNotification.js.map